import { useQuery } from '@tanstack/react-query';
import Packlink from '@sdk';
import { IShipment, Shipment, IProducts, ProProducts } from '@packlink/packlink-sdk';
import { normalizeShipmentInsurance } from '@utils/ShipmentUtils';

export interface UseShipmentsProductsDataResult {
    products: IProducts;
    summaryProducts?: ProProducts['summary']['products'];
}

export function useShipmentProductsData(
    shipment: Shipment<IShipment>,
    insuranceSelected?: boolean,
): UseShipmentsProductsDataResult {
    const normalizedShipment = normalizeShipmentInsurance(shipment, insuranceSelected);

    const { data: products } = useQuery({
        queryKey: ['shipmentProduct', normalizedShipment],
        queryFn: () => Packlink.pro.shipments.products.get([normalizedShipment]),
    });

    return {
        products: products?.productsDetails?.[0]?.products ?? {},
        summaryProducts: products?.summary?.products,
    };
}
